<template>
    <v-card v-if="experimentGroup">
        <v-row class="pt-2">
            <v-col>
                <v-label class="ml-4">Experiment Group</v-label>
                <v-card-title>{{ experimentGroup.name }} - {{ experimentGroup.code }}</v-card-title>
                <v-card-subtitle>{{ experimentGroup.id }}</v-card-subtitle>
            </v-col>
            <v-spacer/>
            <v-col align="right">
                <v-label class="mr-4">Related Schema Config</v-label>
                <v-card-title >{{experimentGroup.schemaConfig.name}}</v-card-title>
                <v-btn class="mr-4" append-icon="$open-in-new"  size="medium" color="primary" variant="text" @click="goToSchemaConfigPage()">{{ experimentGroup.schemaConfig.code }}</v-btn>
            </v-col>
        </v-row>
        <v-card-text>
            <v-tabs v-model="tab" bg-color="info" theme="dark">
                <v-tab value="Details">Details</v-tab>
                <v-tab value="TaskSchedule">Task Schedule</v-tab>
                <v-tab value="ExperimentSetup">Experiment Setup</v-tab>
            </v-tabs>
            <experiment-group-details-tab
                v-if="tab == 'Details'"
                :experiment-group="experimentGroup"
            />
            <experiment-group-experiment-setup-tab
                v-if="tab == 'ExperimentSetup'"
                :experiment-group="experimentGroup"
            />
            <experiment-group-task-schedule
                v-if="tab == 'TaskSchedule'"
                :experiment-group="experimentGroup"
            />
        </v-card-text>
    </v-card>
</template>
<script setup lang="ts">
import {
    ExperimentGroupDTO,
    experimentGroupsAPI,
} from "@/services/experimentGroups/experimentGroupsAPI";
import { useRoute, useRouter } from "vue-router";
import { onMounted, ref } from "vue";
import { withLoadingScreen } from "@/lib/loading";
import ExperimentGroupTaskSchedule from "@/components/ExperimentGroups/ExperimentGroupTaskSchedule.vue";
import ExperimentGroupExperimentSetupTab from "@/components/ExperimentGroups/ExperimentGroupExperimentSetupTab.vue";
import ExperimentGroupDetailsTab from "@/components/ExperimentGroups/ExperimentGroupDetailsTab.vue";

const route = useRoute();
const router = useRouter();
const experimentGroupCode = route.params.code as string;

const experimentGroup = ref<ExperimentGroupDTO>();
const tab = ref("Details");

onMounted(async () => await fetchExperimentGroup());

async function fetchExperimentGroup() {
    await withLoadingScreen(async () => {
        experimentGroup.value = await experimentGroupsAPI.fetchExperimentGroupByCode(experimentGroupCode);
    });
}

function goToSchemaConfigPage() {
    router.push({ path: `/schemaConfigs/${experimentGroup.value!.schemaConfig.code}` });
}

</script>
